// extracted by mini-css-extract-plugin
export default {"pills":"tabs-section-module__pills--DKWTD","rightShadow":"tabs-section-module__rightShadow--X2OVI","leftShadow":"tabs-section-module__leftShadow--AbANx"};